module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-context-menu",
    class: [_vm.shown, {
      'table-context-menu__invert': _vm.isInvert
    }],
    style: ({
      top: ((_vm.coordinates.top) + "px"),
      left: ((_vm.coordinates.left) + "px")
    }),
    attrs: {
      "id": "table-context-menu"
    }
  }, _vm._l((_vm.buttons), function(button) {
    return _c('span', {
      key: button.name,
      staticClass: "table-context-menu_button-wrap"
    }, [(button.type == 'button') ? _c('button', {
      staticClass: "table-context-menu_button",
      class: button.styleClass,
      on: {
        "click": function($event) {
          button.action(_vm.row)
        }
      }
    }, [_c('i', {
      staticClass: "table-context-menu_icon",
      class: button.iconStyleClass
    }), _vm._v("\n      " + _vm._s(button.name) + "\n    ")]) : _c('a', {
      staticClass: "table-context-menu_link",
      class: button.styleClass,
      attrs: {
        "href": button.href(_vm.row),
        "target": button.target
      }
    }, [_c('i', {
      staticClass: "table-context-menu_icon",
      class: button.iconStyleClass
    }), _vm._v("\n      " + _vm._s(button.name) + "\n    ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72700e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableContextMenu.vue
// module id = 139
// module chunks = 0